import { ApiEndpoint } from "@/app/apiEndpoint";
import axios from "@/app/http/axios";
import { Role } from "@/interface/Role.interface";

export default class RoleService {
  constructor() {}

  async getRoles() {
    const path = ApiEndpoint.Role.ROLE_ALL;
    try {
      const response = await axios.get<Role[]>(`${path}`, {
        headers: { "Content-Type": "application/json" },
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }

   async getUsers() {
    const path = ApiEndpoint.Role.USER_ALL;
    try {
      const response = await axios.get(`${path}`, {
        headers: { "Content-Type": "application/json" },
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }

   async saveUserRole(userId: number, roles: any) {
    const path = ApiEndpoint.Role.UPDATE_USER_ROLE;
    try {
      const response = await axios.patch<any>(
        `${path.replace("{id}", userId.toString())}`,
        roles
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }
}
